<template>
  <div class="row">
    <div class="col-md-12">
      <h2 class="pull-left">세트 목록</h2>
      <div class="row pull-right">
        <input v-model="setId" class="col-md-8 mr-2 form-control" type="text" />
        <button class="col-md-3 btn btn-primary" @click="addSet(setId)">추가</button>
      </div>
      <table class="table table-bordered">
        <tr>
          <th class="col-md-2 text-center">세트 ID</th>
          <th class="col-md-9 text-center">제목</th>
          <th class="col-md-1"></th>
        </tr>
        <tbody>
          <tr v-for="set in sets" :key="set.id">
            <td class="col-md-2">{{ set.id }}</td>
            <td class="col-md-9">{{ set.title }}</td>
            <td class="col-md-1">
              <button class="btn btn-warning" @click="removeSet(set.id)">제거</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <update-error-modal
      :message-html="updateErrorModalMessageHtml"
      :modal-id="'set-list-modal-fail'"
    ></update-error-modal>
  </div>
</template>

<script>
import helpers from '../helpers/helpers';
import UpdateErrorModal from './UpdateErrorModal';

export default {
  components: {
    UpdateErrorModal,
  },
  props: {
    initialSets: {
      type: Array,
      required: true,
    },
    rewardId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      sets: this.initialSets,
      setId: '',
      updateErrorModalMessageHtml:
        '<p>저장하는 도중 오류가 발생하였습니다.<br> 다시 한번 저장한 후에도 같은 문제가 계속된다면 관리자에게 문의해 주세요.</p>',
    };
  },
  created() {},
  methods: {
    addSet(setId) {
      if (_.isEmpty(setId)) {
        return;
      }

      const url = location.protocol + '//' + location.hostname + '/api/reward/' + this.rewardId + '/add_set';
      this.$http
        .post(url, {
          set_id: setId,
        })
        .then(response => {
          const set = response.data.success.data;
          this.sets.push(set);
        })
        .catch(error => {
          this.alertUpdateFailText(error.response);
        });

      this.setId = '';
    },
    removeSet(setId) {
      const url = location.protocol + '//' + location.hostname + '/api/reward/' + this.rewardId + '/remove_set';
      this.$http
        .post(url, {
          set_id: setId,
        })
        .then(response => {
          const index = _.findIndex(this.sets, set => {
            return set.id === setId;
          });

          this.sets.splice(index, 1);
        })
        .catch(error => {
          this.alertUpdateFailText(error.response);
        });
    },
    alertUpdateFailText(response) {
      if (response.status === 401) {
        this.updateErrorModalMessageHtml =
          '<p>장시간 저장하지 않아 세션이 만료되었습니다.<br>작성하신 내용을 저장하시려면?<br>새 탭에서 로그인하신 후, 현재 탭에서 [저장하기] 버튼을 다시 클릭해 주세요.</p>';
      } else {
        try {
          this.updateErrorModalMessageHtml = response.data.error.message;
        } catch (e) {
          this.updateErrorModalMessageHtml =
            '<p>글을 저장하는 도중 오류가 발생하였습니다.<br> 다시 한번 저장한 후에도 같은 문제가 계속된다면 관리자에게 문의해 주세요.</p>';
        }
      }

      $('#set-list-modal-fail').modal();
    },
  },
};
</script>
